import {
  withTypes,
  Field,
} from 'react-final-form';
import classNames from 'classnames';
import { t } from 'ttag';

import defaultAvatarImage from '@static/img/default-avatar.png';
import { required } from '@utils/validators';
import { Modal } from '@ui/Modal';
import { Button } from '@ui/Button';
import { Image } from '@ui/Image';
import { TextArea } from '@ui/TextArea';
import { FormError } from '@ui/FormError';
import { ProductModalBackground } from '@components/ProductModalBackground';

import s from './ProductDetailsQuestionFormModal.sss';

export interface FormData {
  body?: string,
}

interface ProductPhoto {
  id: string,
  idStr?: string | null,
  thumbnailUrl: string,
}

export interface User {
  username: string,
  thumbnail?: string | null
}

export interface Product {
  name: string,
  photos: ProductPhoto[],
}

interface Props {
  className?: string,
  isOpen: boolean,
  user: User,
  product: Product,
  onSubmit: (formData: FormData) => void,
  onClose: () => void,
}

export const ProductDetailsQuestionFormModal: React.FC<Props> = ({
  className,
  isOpen,
  user,
  product,
  onSubmit,
  onClose,
}) => {
  const { Form } = withTypes<FormData>();

  return (
    <Modal
      className={s.modal}
      withClose={true}
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Modal"
    >
      <div className={classNames(s.root, className)}>
        <ProductModalBackground
          productName={product.name}
          productImg={product.photos[0].thumbnailUrl}
        />
        <div className={s.container}>
          <Image
            className={s.avatar}
            width="40"
            height="40"
            src={user.thumbnail || defaultAvatarImage}
            alt={user.username}
            lazy={true}
          />

          <Form
            onSubmit={onSubmit}
            render={({ handleSubmit, submitting, submitError }) => (
              <form
                className={s.form}
                onSubmit={handleSubmit}
              >
                <Field
                  name="body"
                  validate={required}
                >
                  {({ input, meta }) => (
                    <>
                      <TextArea
                        className={s.textarea}
                        placeholder={t`Текст повідомлення`}
                        rows={4}
                        disabled={submitting}
                        invalid={(meta.touched && meta.error) || meta.submitError}
                        error={(meta.touched && meta.error) || meta.submitError}
                        {...input}
                        value={input.value || ''}
                      />
                      {submitError && (
                      <FormError>
                        {submitError}
                      </FormError>
                      )}
                    </>
                  )}
                </Field>

                <div className={s.footer}>
                  <Button
                    className={s.submit}
                    type="submit"
                    disabled={submitting}
                  >
                    {submitting ? t`Надсилання...` : t`Надіслати`}
                  </Button>
                </div>
              </form>
            )}
          />
        </div>
      </div>
    </Modal>
  );
};
